export const DentOptCash = "DentOptCash";
export const PrivateGP = "PrivateGP";
export const TravelEU = "TravelEU";
export const TravelWorld = "TravelWorld";
export const EAPEssential = "EAPEssential";
export const EAPPremier = "EAPPremier";
export const Treatment = "Treatment";
export const TreatmentNHS = "TreatmentNHS";
export const Diagnostics = "Diagnostics";
export const StandardOP = "StandardOP";
export const FullOP = "FullOP";
export const EnhancedOP = "EnhancedOP";
export const Therapies = "Therapies";
export const MentalHealth = "MentalHealth";
export const ExtendedCover = "ExtendedCover";
export const DentOptCashPlus = "DentOptCashPlus";
